import NextImage from 'next/image'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { useConversationStore } from 'stores/conversation'
import { useSETrackEvent } from 'app/ConversationPage/hooks/useSETrackEvent'

interface IMessageFeedbackProps {
  index: number
  message: string
  onCopy: () => void
  onLike: () => void
  onDislike: () => void
}
const MessageFeedback: React.FC<IMessageFeedbackProps> = ({
  index,
  message,
  onCopy,
  onLike,
  onDislike,
}) => {
  const { conversationId } = useConversationStore()
  const { SETrackConversationPage } = useSETrackEvent()

  const clickLearnMoreHandler = () => {
    SETrackConversationPage('CLICK_GURU_AI_PELAJARI_LEBIH_LANJUT', {
      ai_chat_session_id: conversationId,
      is_new_ai_chat_session: [false, 'bool'],
    })
  }

  return (
    <>
      {[1, 3].includes(index) && (
        <div className="relative p-4 mt-4 mb-2 bg-[#EFF0F0] after:content-[''] after:w-0 after:h-0 after:border-l-[15px] after:border-r-[15px] after:border-l-transparent after:border-r-transparent  after:border-t-[20px] after:border-t-[#EFF0F0] after:absolute after:bottom-[-15px] after:right-[135px]">
          <Text>
            Klik jempol ini kalau Anda suka/tidak suka, agar Asisten Guru
            berkembang lebih baik lagi.
          </Text>
        </div>
      )}

      <div className="flex items-center justify-end p-4 space-x-8">
        <button
          data-testid="conversation-message-feedback-like"
          aria-label="Menyukai"
          className="flex items-center"
          onClick={onLike}
        >
          <Icon className="!text-[#808489]">thumb_up_outline</Icon>
        </button>

        <button
          data-testid="conversation-message-feedback-dislike"
          aria-label="Tidak Menyukai"
          className="flex items-center"
          onClick={onDislike}
        >
          <Icon className="!text-[#808489]">thumb_down_outline</Icon>
        </button>

        <CopyToClipboard text={message} onCopy={onCopy}>
          <button
            data-testid="conversation-message-feedback-copy"
            aria-label="Salin"
            className="flex items-center space-x-1"
          >
            <Icon className="!text-[#808489]">content_copy</Icon>
            <Text variant="action" color="subdued">
              Salin
            </Text>
          </button>
        </CopyToClipboard>
      </div>

      <div className="flex items-end p-4 space-x-1 bg-cyan-5">
        <div>
          <div className="mb-1">
            <Text variant="action">Ingin jawaban lebih bagus?</Text>
          </div>

          <div className="mb-4">
            <Text variant="body-sm" color="subdued">
              Ketik pesan lengkap dengan detail situasi, kondisi, atau kebutuhan
              Anda.
            </Text>
          </div>

          <div>
            <Button
              as="a"
              href={`${process.env.NEXT_PUBLIC_PUSAT_INFORMASI_BASE_URL}/hc/id/articles/28896707281817-Trik-Meningkatkan-Efektivitas-Pencarian-Informasi-dengan-Asisten-Guru`}
              color="white"
              size="sm"
              className="!bg-cyan-5 !w-auto !inline"
              target="_blank"
              onClick={clickLearnMoreHandler}
            >
              Pelajari lebih lanjut
            </Button>
          </div>
        </div>
        <div className="flex-none w-[84px] h-[84px]">
          <NextImage
            src="/illustrations/img-chat-talk.png"
            alt="Gambar ilustrasi Pusat Bantuan"
            layout="responsive"
            height="84px"
            width="84px"
          />
        </div>
      </div>
    </>
  )
}

export default MessageFeedback
